"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spinner = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactFela = require("react-fela");

var _view = require("../view");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Spinner = function Spinner() {
  var _useFela = (0, _reactFela.useFela)(),
      theme = _useFela.theme;

  return /*#__PURE__*/_react["default"].createElement(_view.View, {
    className: "loader loader--style3",
    title: "2"
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    version: "1.1",
    x: "0px",
    y: "0px",
    width: "60px",
    height: "60px",
    viewBox: "0 0 50 50",
    xmlSpace: "preserve"
  }, /*#__PURE__*/_react["default"].createElement(_view.View, {
    as: "circle",
    extend: styles.border({
      theme: theme
    }),
    cx: "25",
    cy: "25",
    r: "17"
  }), /*#__PURE__*/_react["default"].createElement(_view.View, {
    as: "path",
    extend: styles.colored({
      theme: theme
    }),
    d: "M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
  }, /*#__PURE__*/_react["default"].createElement("animateTransform", {
    attributeType: "xml",
    attributeName: "transform",
    type: "rotate",
    from: "0 25 25",
    to: "360 25 25",
    dur: "0.8s",
    repeatCount: "indefinite"
  }))));
};

exports.Spinner = Spinner;
var styles = {
  root: function root(_ref) {
    var grid = _ref.theme.layout.grid;
    return {
      padding: 2 * grid
    };
  },
  colored: function colored(_ref2) {
    var primary = _ref2.theme.colors.primary;
    return {
      fill: primary
    };
  },
  border: function border(_ref3) {
    var _border = _ref3.theme.colors.border;
    return {
      fill: 'none',
      stroke: _border,
      strokeWidth: 4
    };
  }
};